interface LeaveRequestPayload {
    eventType: 'leave_request_created';
    leaveId: string;
    title: string;
    userName: string;
    userEmail: string;
    supervisorEmail: string;
    startDate: string;
    endDate: string;
    allDay: boolean;
    comment: string;
}

export const sendLeaveRequestToN8n = async (
    leaveId: string,
    title: string,
    userName: string,
    userEmail: string,
    supervisorEmail: string,
    startDate: Date,
    endDate: Date,
    allDay: boolean,
    comment: string
): Promise<{ success: boolean; error?: string }> => {
    const N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_CREATE_LEAVE_REQUEST_URL;

    if (!N8N_WEBHOOK_URL) {
        return { success: false, error: 'Webhook URL no configurada' };
    }

    try {
        const payload: LeaveRequestPayload = {
            eventType: 'leave_request_created',
            leaveId,
            title,
            userName,
            userEmail,
            supervisorEmail,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            allDay,
            comment,
        };


        const response = await fetch(N8N_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error('Error n8n:', response.status);
            return { success: false, error: `HTTP ${response.status}` };
        }

        return { success: true };

    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido'
        };
    }
};